import { ReadOutlined } from "@ant-design/icons";

/**
 * What shows where the topics go while a reader has none: before any content
 * is written, or when every topic is for a module the tenant lacks. It points
 * to the contact card, which is always at the foot of the Help Centre.
 */
function HelpComingSoon() {
	return (
		<div className="help-coming-soon">
			<ReadOutlined className="help-coming-soon__icon" aria-hidden="true" />
			<p className="help-coming-soon__title">Help articles are on their way</p>
			<p className="help-coming-soon__text">
				In the meantime, our support team is happy to help. Use the Contact
				support button at the bottom of the page.
			</p>
		</div>
	);
}

export default HelpComingSoon;
